import { atom } from 'recoil';

/**
 * Tracks whether the main navigation menubar is currently visible.
 * Used by scroll-aware components to adjust their positioning.
 * 
 * When scrolling down: menubar hides (false)
 * When scrolling up: menubar shows (true)
 * At top of page: menubar always shows (true)
 */
export const menubarVisibleAtom = atom<boolean>({
  key: 'menubarVisibleAtom',
  default: true,
});

/**
 * Height of the menubar in pixels, used for positioning calculations.
 * This is exported as a constant rather than an atom since it doesn't change.
 */
export const MENUBAR_HEIGHT = 56; // 48px menubar + 8px spacing

